module.exports = __webpack_public_path__ + "img/uni-eth-wbtc.08103cfb.svg";